export enum OrderType {
    DELIVERY = 'delivery',
    PICKUP = 'pickup'
}
